<section class="tw-relative">
  <input
    #searchSelectInput
    type="text"
    autocomplete="off"
    role="combobox"
    aria-autocomplete="list"
    [attr.aria-label]="placeholder() || selection()?.label || ''"
    [attr.aria-expanded]="openBox()"
    [attr.aria-controls]="openBox() ? 'searchSelectMenu-' + componentId : null"
    [attr.aria-activedescendant]="openBox() && markedIndex() >= 0 ? 'searchSelectOption-' + componentId + '-' + markedIndex() : null"
    class="form-control {{customClassInput()}}"
    [class.tw-pr-8]="selection() && !isDisabled()"
    [placeholder]="selection() ? '' : placeholder()"
    [value]="filterValue()"
    [disabled]="isDisabled()"
    (input)="onInput($event)"
    (keydown)="onKeyDown($event)"
    (focus)="handleFocus()"
    (blur)="handleBlur()"
  />

  @if (selection() && !filterValue()) {
    <span
      class="tw-absolute tw-inset-y-0 tw-left-0 tw-right-8 tw-px-3 tw-flex tw-items-center tw-truncate tw-pointer-events-none"
    >
      {{ selection()!.label }}
    </span>
  }

  @if (selection() && !isDisabled()) {
    <button
      type="button"
      class="tw-absolute tw-right-2 tw-inset-y-0 tw-flex tw-items-center tw-text-main-text hover:tw-text-black"
      [attr.aria-label]="'core-lib.input.search_select.clear' | translate"
      [title]="'core-lib.input.search_select.clear' | translate"
      (mousedown)="onOptionMouseDown($event)"
      (click)="clearSelection($event)"
    >
      <i class="far fa-times"></i>
    </button>
  }

  @if (openBox() && (displayedOptions().length || noResultsVisible())) {
    <div [id]="'searchSelectMenu-' + componentId" class="tw-absolute tw-w-full tw-z-10 tw-mt-1">
      <article class="tw-rounded-lg tw-shadow-tb tw-p-3 tw-bg-white tw-mt-1 tw-overflow-hidden">
        <section class="tw-py-2 tw-max-h-[220px] tw-overflow-auto" role="listbox">
          @if (displayedOptions().length) {
            @for (option of displayedOptions(); track option.value; let i = $index) {
              <article
                [id]="'searchSelectOption-' + componentId + '-' + i"
                role="option"
                [attr.aria-selected]="option.value === selection()?.value"
                class="tw-p-2 tw-cursor-pointer hover:tw-bg-background-gray/50 search-select-option"
                [class.search-select-option-marked]="i === markedIndex()"
                (mousedown)="onOptionMouseDown($event)"
                (click)="selectOption(option)"
              >
                {{ option.label }}
              </article>
            }
          } @else {
            <p class="tw-p-2 tw-text-main-text tw-text-sm">
              {{ noResultsText() || ('core-lib.input.search_select.no_results' | translate) }}
            </p>
          }
        </section>
      </article>
    </div>
  }
</section>
